import { TeamSlider } from '../../../js/src/__utils/sliders';
import teamCards, {
	closeModal,
	outsideClick,
} from '../../../js/src/__blocks/teamCards';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		TeamSlider.init();
		teamCards();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown(e) {
		if (e.keyCode === 27) {
			closeModal();
		}
	},
	mouseUp(e) {
		outsideClick(e);
	},
};
export default controller;
